var _path, _line, _line2, _line3, _line4, _path2, _path3, _line5, _line6, _line7, _line8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 44,
    viewBox: "0 0 64 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8496 21.8618L57.8666 23.2681C55.6048 26.504 51.9054 28.4316 47.9574 28.4316V28.4316C43.821 28.4316 39.9716 26.317 37.7532 22.8258L37.1406 21.8618",
    stroke: "white",
    strokeWidth: 1.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 55.3133,
    y1: 25.507,
    x2: 57.5985,
    y2: 27.7921,
    stroke: "white",
    strokeWidth: 1.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 3.2317,
    y2: -0.7,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 40.5352 26.002)",
    stroke: "white",
    strokeWidth: 1.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 3.2317,
    y2: -0.7,
    transform: "matrix(-0.318132 0.948047 0.948047 0.318132 45.9668 28.082)",
    stroke: "white",
    strokeWidth: 1.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 50.6011,
    y1: 27.8593,
    x2: 51.6292,
    y2: 30.9231,
    stroke: "white",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13141 23.0229C8.39329 19.787 12.0926 17.8594 16.0407 17.8594V17.8594C20.1771 17.8594 24.0264 19.9741 26.2449 23.4652L26.8574 24.4292L26.2449 25.3932C24.0264 28.8843 20.1771 30.999 16.0407 30.999V30.999C12.0926 30.999 8.39329 29.0714 6.13141 25.8355L5.14844 24.4292L6.13141 23.0229Z",
    stroke: "white",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2891 24.4282C12.2891 22.3774 13.9516 20.7148 16.0024 20.7148V20.7148C18.0533 20.7148 19.7158 22.3774 19.7158 24.4282V24.4282C19.7158 26.4791 18.0533 28.1416 16.0024 28.1416V28.1416C13.9516 28.1416 12.2891 26.4791 12.2891 24.4282V24.4282Z",
    stroke: "white",
    strokeWidth: 1.4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 8.65346,
    y1: 20.6395,
    x2: 6.36831,
    y2: 18.3543,
    stroke: "white",
    strokeWidth: 1.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 3.2317,
    y2: -0.7,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 23.4316 20.1445)",
    stroke: "white",
    strokeWidth: 1.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 3.2317,
    y2: -0.7,
    transform: "matrix(0.318132 -0.948047 -0.948047 -0.318132 18 18.0645)",
    stroke: "white",
    strokeWidth: 1.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 13.3657,
    y1: 18.2871,
    x2: 12.3376,
    y2: 15.2233,
    stroke: "white",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesIcon);
export default __webpack_public_path__ + "static/media/eyes-icon.5813a540fdcec0eca58c5f1bb9825309.svg";
export { ForwardRef as ReactComponent };